import React, { useState, useEffect, useRef } from 'react'
import { Button, Typography } from 'antd'
const { Paragraph } = Typography
import { useParams } from 'react-router-dom'

import { useAwards } from 'data/hooks'


export const Redimer = props => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { award, allowRedim } = props
  const { status, awardCode } = award
  const { redeemAward } = useAwards(gameId)
  const btn = useRef()

  const copyToClipboard = () => {}
  const redeem = () => { 

    btn.current.disabled = true
    redeemAward(award.awardId)
  }

  return (<>
    { (allowRedim || awardCode) &&
      <div className={`redim`}>
        { allowRedim && status === 'pending' && 
          <Button type="link"
                  onClick={redeem}
                  ref={btn}
          >Solicitar código</Button>
        }
        { allowRedim && status === 'error' &&
          <div className="error">
            Error en la solicitud
          </div>
        }
        { allowRedim && status == 'redeemed' &&
          <div className="redeemed">Código solicitado</div>
        }
        { status == 'approved' &&
          <>
            { /*
            <div className="explanation">
              Este es tu código a canjear
            </div>
            */ }
            <div className="approved">
              <Paragraph copyable={{tooltips: ['Copiar código', 'Copiado!!']}} className="code">{ awardCode }</Paragraph>
              <div className="copy-code"
                  onClick={()=>copyToClipboard(awardCode)}
              ></div>
            </div>
          </>
        }
      </div>
    }
  </>)
}
